import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from './api.service';
import {Config} from '../../../config/config';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private apiService: ApiService) {
  }

  public search(term: string): Observable<any> {
    return this.apiService.get(Config.ENDPOINTS.search.search(term));
  }
}
